import RequestConfirmModal from './RequestConfirmModal';

export default RequestConfirmModal;



// WEBPACK FOOTER //
// ./src/components/RequestConfirmModal/index.js